import "../Css/ChoosingInstitute.css";
import img from "../assets/img.webp"

const ChoosingInstitute = () => {
  return (
    <section className="choose-section">
      <div className="choose-container">

        {/* LEFT CONTENT */}
        <div className="choose-content">
          <h2>Choosing the Right Coaching Institute for your Child</h2>

          <p>
            If your goal for your child is to excel in Engineering or Medical
            entrance examinations, it is important to choose the right coaching
            institute from the many available options.
          </p>

          <p>
            Today, parents often find themselves confused between personal tutors,
            local coaching centers, and large national-level institutes. Each comes
            with its own strengths and limitations.
          </p>

          <p>
            Large coaching institutes usually follow a fixed teaching structure,
            where students are grouped based on performance. While top-performing
            students receive the best faculty, average students may struggle to
            keep pace with the teaching methodology.
          </p>

          <p>
            Smaller coaching centers, on the other hand, provide personalized
            attention and flexible learning, helping students understand concepts
            at their own speed and clear doubts more effectively.
          </p>

          <p>
            Choosing a stable institute with experienced faculty, consistent
            teaching staff, and transparent fee structures plays a crucial role
            in your child’s academic success.
          </p>

          <ul>
            <li>Look for personalized attention and mentoring</li>
            <li>Check faculty stability and teaching experience</li>
            <li>Understand batch size and doubt-solving approach</li>
            <li>Attend demo classes before finalizing</li>
            <li>Ensure flexible exit options if required</li>
          </ul>
        </div>

        {/* RIGHT IMAGE */}
        <div className="choose-image">
          <img src={img} />
        </div>

      </div>
    </section>
  );
};

export default ChoosingInstitute;
